
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"11","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_342_1606)"}},[_c('path',{attrs:{"d":"M5.618 2.987l-3.791 3.54a.408.408 0 000 .605.478.478 0 00.605.035l3.084-2.88v8.417c0 .234.204.426.457.426.252 0 .458-.192.458-.426V4.287l3.158 2.95a.492.492 0 00.547-.07.41.41 0 00.13-.303.47.47 0 00-.153-.342l-.251-.235-.694-.65-.128-.122-2.709-2.528a.472.472 0 00-.347-.12h-.019a.47.47 0 00-.347.12z","fill":"#fff","stroke":"#fff","stroke-width":".765"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_342_1606"}},[_c('path',{attrs:{"fill":"#fff","transform":"rotate(-90 8 8)","d":"M0 0h16v11H0z"}})])])])
          )
        }
      }
    